import React from "react";
import ChartModal from "./ChartModal";
import PositionDistribution from "./PositionDistribution";
import "./PositionDistributionModal.css";

const PositionDistributionModal = ({
  isOpen,
  onClose,
  data,
  excludedDomains = [],
  title = "Répartition des positions par domaine",
}) => (
  <ChartModal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    className="position-distribution-modal-content"
  >
    <PositionDistribution
      data={data}
      excludedDomains={excludedDomains}
      maxDomains={Infinity}
    />
  </ChartModal>
);

export default PositionDistributionModal;
